import { useMemo } from 'react'
import { LabRemoteConfigKeys } from 'constants/lab'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { getVisibleLanguageOptions } from 'i18n/util/locale'
import { useAppSelector } from 'hooks/reduxHooks'

export function useLocaleUrlOptions() {
  const locale = useAppSelector(state => state.geo.locale)
  const languagesRemoteConfig = useLabRemoteConfig(LabRemoteConfigKeys.languages)
  const languageOptions = useMemo(() => getVisibleLanguageOptions(languagesRemoteConfig), [languagesRemoteConfig])
  return { locale, languageOptions }
}
